export enum DeviceGuarding {
  ENABLED = 'arm',
  DISABLED = 'disarm',
}
